import setupApolloClient from "../apollo";

export default {
  initialize: setupApolloClient
};
